import { render, staticRenderFns } from "./DTabs.vue?vue&type=template&id=fbb37c6a&scoped=true&"
import script from "./DTabs.vue?vue&type=script&lang=js&"
export * from "./DTabs.vue?vue&type=script&lang=js&"
import style0 from "./DTabs.vue?vue&type=style&index=0&id=fbb37c6a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbb37c6a",
  null
  
)

export default component.exports